import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getHighRiskActivity = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/vehicles/high-theft`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("High Risk Activity data fetch error:", error);
    throw error;
  }
};

const addHighRiskActivity = async (data) => {
  try {
    const token = getToken();

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/vehicles/suspected-theft`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("High Risk Activity data add error:", error);
    throw error;
  }
};

export { getHighRiskActivity, addHighRiskActivity };
